export const theme = {
  primary: {
    mainBackground: "hsla(200, 9%, 13%, 1)",
    primaryTextColor: "hsla(56, 32%, 91%, 1)",
    docPadding: "1.5rem",
    tertTextColor: "hsla(56, 32%, 91%, 0.25)",
    weight700: "700",
    weight400: "400",
    whiteText: " hsla(0, 0%, 100%, 1)",
  },
};
